<template>
    <CRow>
        <CCol col="12" sm="6" class="mx-auto p-0">
            <CCard v-for="(notification, index) in notifications" :key="index" class="notification-me" :class="notification.read_at ? 'mark-as-read' : ''">
                <CCardBody>
                    <span class="float-right badge badge-affili-witch-haze mb-2" style="top:10px;left:10px;">{{ notification.data.type }}</span>
                    <h5 class="h6 mb-0">{{ notification.data.subject }}</h5>
                    <VRuntimeTemplate class="m-0 font-sm b-a-1 p-2" :template="'<div>'+notification.data.content+'</div>'" />
                </CCardBody>
                <CCardFooter v-if="!notification.read_at">
                    <CButton @click="setMarkAsRead(notification.id)" class="btn btn-link text-affili-coral mr-auto d-block">
                        <span>خوانده شده</span>
                        <FaIcon icon="check" class="mfs-1" />
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import fields from './fields'
import { mapGetters, mapActions } from 'vuex'
import VRuntimeTemplate from "v-runtime-template";

export default {
    name: 'List',

    components: {
        VRuntimeTemplate
    },

    data() {
        return {
            fields,
            contentModal: {
                show: false,
                item: ''
            },
        }
    },

    computed: {
        ...mapGetters({
            notifications: 'notification/notifications',
            // pagination: 'notification/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    methods: {
        ...mapActions({
            fetch: 'notification/fetch',
            markAsRead: 'notification/markAsRead',
        }),
        // fetchNotifications(activePage, params = false) {
        //     this.fetch({
        //         page: activePage,
        //         ...params,
        //         ...this.filterMeFields
        //     })

        //     this.pagination.page = activePage
        // },
        setMarkAsRead(notificationId) {
            this.markAsRead(notificationId)
        }
    },
}
</script>

<style>
.mark-as-read, .mark-as-read * {
    color: #636f83 !important; /* text-dark */
    background-color: #ebedef !important; /* bg-gray-100 */
}
.mark-as-read a.btn {
    background-color: #b1b7c1 !important; /* bg-gray-400 */
    border-color: #c4c9d0 !important;
}
.mark-as-read .badge {
    background-color: #b1b7c1 !important; /* bg-gray-400 */
}
.notification-me .btn:focus {
    box-shadow: none !important;
}
</style>